import { Model } from 'core/models';

export class ERouteType extends Model {
    public id?: number;
    public code?: string;
    public name?: string;
}
